import React from 'react';
import { Button } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
	const { i18n, t } = useTranslation('app');

	const toggle = () => {
		const next = i18n.language === 'en' ? 'es' : 'en';
		i18n.changeLanguage(next);
	};

	return (
		<Button
			size="small"
			variation="link"
			onClick={toggle}
			fontWeight="600"
			fontSize="14px"
			color="rgba(0,0,0,0.7)"
		>
			{t('nav.language')}
		</Button>
	);
}
